import { get, post, remove } from "api";
import { ADVERTISEMENTS_ENDPOINTS } from "api/endpoints/advertisements";
import {
  TAdvertisement,
  TAdvertisementCreateBody,
} from "types/api/advertisement";
import { TUrlParam } from "types/utils";

export const getAdvertisements = (): Promise<TAdvertisement[]> =>
  get<TAdvertisement[]>(ADVERTISEMENTS_ENDPOINTS.ROOT);

export const getAdminAdvertisements = (): Promise<TAdvertisement[]> =>
  get<TAdvertisement[]>(ADVERTISEMENTS_ENDPOINTS.ADMIN_ROOT);

export const createAdvertisement = (
  body: TAdvertisementCreateBody
): Promise<TAdvertisement> =>
  post<TAdvertisement>(ADVERTISEMENTS_ENDPOINTS.ADMIN_ROOT, body);

export const deleteAdvertisement = (id: TUrlParam): Promise<void> =>
  remove<void>(ADVERTISEMENTS_ENDPOINTS.ADMIN_ID(id));
